import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Deal } from 'app/models/dto/deal.model';
import { EventBusService } from 'app/modules/shared/services/event-bus.service';
import { SaveDealStatus } from 'app/store/deal/deal/deal.actions';

@Component({
  selector: 'app-reactivate-deal-dialog',
  templateUrl: './reactivate-deal-dialog.component.html',
  styleUrls: ['./reactivate-deal-dialog.component.scss']
})
export class ReactivateDealDialogComponent implements OnInit {

  constructor(
    private store: Store,
    @Inject(MAT_DIALOG_DATA) public deal: Deal,
    private dialogRef: MatDialogRef<ReactivateDealDialogComponent>,
    private eventBusService: EventBusService
  ) { }

  ngOnInit(): void {}

  reactivateDeal() {
    this.store.dispatch(
      new SaveDealStatus(
        this.deal.id,
        this.deal.last_active_status.stage,
        this.deal.last_active_status.status,
        '',
        [],
        []
      )
    );
    this.dialogRef.close();
    this.eventBusService.publish(new this.eventBusService.types.GoToActiveTabEvent);
  }
}
